import { updateLinksAttributes } from '../utils/handleAttributes';
import managedBackground from '../utils/managedBackground';

function hotButtons() {
  const widgetName = 'hotButtons';
  const widgetOpts = hotButtonsOpts;
  const $widget = $(`#${widgetName}`);
  const wrapContainerClass = 'hotbuttons-container';

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return new Promise((resolve) => {
    return saffire.widgets.cardWidget($($widget), {
      currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
      scriptPath: widgetOpts.scriptPath,
      link: ['all'],
      hasImages: false,
      lazyLoadImages: false,
      imageIsBackground: false,
      textOverImage: true,
      maxItemsVisible: 5,
      itemsPerPanel: 1,

      cardWidgetLoaded: function (data, _owl, hasData) {
        if (hasData) {
          createHotButtons(data.items, $widget);
          resolve(true);
        } else {
          $(`.${wrapContainerClass}`).remove();
          resolve(false);
        }
      },
    });
  });
}

function createHotButtons(widgetData, $widget) {
  $widget.find('.card-widget-item').each(function (x) {
    const { Title, URL } = widgetData[x];
    const $hotButton = $(this);

    $hotButton.replaceWith(`
        <a ${URL == null || URL === '' ? '' : 'href="' + URL + '"'} class="hot-btn${URL == null || URL === '' ? ' void-link' : ''}" ${updateLinksAttributes(URL, Title)}>
          <span class="hot-btn-title">${Title}</span>
        </a>
        `);

    updateLinksAttributes(URL, Title, $hotButton);
  });
}

export default async function renderButtonsWithBackground() {
  const hasHotButtons = await hotButtons();

  if (hasHotButtons) {
    managedBackground({
      widgetConfigName: 'backgroundHotButtons',
      widgetConfigOpts: backgroundHotButtonsOpts,
      widgetConfigDestination: '.hotbuttons-container',
      widgetConfigContainerClass: 'managed-bg',
    });
  }
}
